import { Outlet, useNavigate } from 'react-router-dom';// desde la V6 es routes no switch
import { Container, IconButton, Toolbar } from '@mui/material';
import logoespol from '../../recursos_iconos/Portal_Investigacion_r.svg';
import { FaUserTie } from "react-icons/fa";
import '../Icono/cardIcon.css';
import Footer from '../Footer/Footer';
import AuthButtons from '../../helpers/EntraId/AuthButton';
import { BsLink45Deg } from 'react-icons/bs';
import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { useCasUserContext } from '../../services/casUserContext';


export default function PortalInvestigacionLayout() {
    let history = useNavigate(); const { accounts } = useMsal();
    const isAuthenticated = accounts.length > 0;
    const casUserContext = useCasUserContext();
    const goToNavigation = (site: string) => {
        history(site)
    }

    useEffect(() => {
        if (isAuthenticated && !casUserContext.checking) {
            // Si hay sesión activa, mando al home privado
            window.location.replace("/");
        }
    }, [isAuthenticated, casUserContext.checking]);

    if (isAuthenticated) {
        return null; // mientras redirige
    }


    return (
        <div>
            <div className='centrado' style={{ paddingTop: '25px', paddingBottom: '25px', borderBottom: '2px solid #243165', display: 'flex', justifyContent: 'space-between' }} >
                <img className='imgBox' width='350px' height='auto' src={logoespol} alt="" style={{ marginLeft: '10%' }} onClick={() => { goToNavigation('/inicio/portalinvestigacion') }} />
                {/* <IconButton color="default" style={{ color: '#243165', padding: '30px' }} onClick={() => goToNavigation('/')}>
                    <FaUserTie />
                </IconButton> */}
                <div style={{ display: 'flex', gap: '10px', marginRight: '10%' }}>
                    <IconButton color="default" style={{ color: '#243165' }} onClick={() => goToNavigation('/')}>
                        <BsLink45Deg />
                    </IconButton>
                    <AuthButtons />
                </div>
            </div>
            <Container maxWidth="lg" style={{ paddingTop: '50px', paddingBottom: '50px' }}>
                <div className='wrapper'>
                    <Outlet />
                </div>
            </Container>
            <div>
                <Footer />
            </div>
        </div>
    );
}
